import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="px-4 md:px-6 lg:px-10 py-14 md:py-20 lg:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="bg-primary-500 rounded-3xl p-8 md:p-12 lg:p-16 text-center relative overflow-hidden">
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-primary-400/20 -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-primary-400/20 translate-y-1/2 -translate-x-1/4"></div>

          <div className="relative z-10 max-w-2xl mx-auto">
            <div className="w-14 h-14 rounded-full bg-background-50/20 flex items-center justify-center mx-auto mb-6">
              <i className="ri-upload-cloud-2-line text-background-50 text-2xl"></i>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
              Upload Your Fire Safety Documents
            </h2>
            <p className="text-background-100/90 text-base md:text-lg leading-relaxed mb-8">
              Submit your fire safety plans, risk assessments, or compliance documents for review. 
              Our SCDF-certified engineers will assess your submission and provide feedback within 
              2 business days.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-background-50 text-primary-600 text-sm md:text-base font-semibold hover:bg-background-100 transition-colors shadow-lg whitespace-nowrap"
              >
                Start Document Upload
                <i className="ri-arrow-right-line text-lg"></i>
              </Link>
              <Link
                to="/products"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-background-50/40 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap"
              >
                <i className="ri-fire-line text-lg"></i>
                Browse Products
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}